import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Dialog, Typography } from '@chilecompra/react-kit/components'

import { onCloseQuoteSaveErrorDialog } from '../QuoteStepOne/QuoteStepOne.actions'
import { CircleErrorIcon, DialogWrapper, Row } from './QuoteErrorDraftDialog.styles'

import { topPage } from '../../modules/utils/topPage'
import { inIframe } from '../../modules/utils/inIframe'

/**
 * The QuoteErrorDraftDialog's container.
 */
const QuoteErrorDraftDialog = () => {
  const dispatch = useDispatch()
  const isInIframe = useMemo(() => inIframe(), [])

  const { openSaveErrorDialog, errors } = useSelector(state => state.quoteStepOne)

  const handleCloseErrorDialog = () => dispatch(onCloseQuoteSaveErrorDialog())

  useEffect(() => topPage(isInIframe, openSaveErrorDialog), [openSaveErrorDialog])

  return (
    <Dialog disableBackdropClick open={openSaveErrorDialog} verticalAlign="top" onClose={handleCloseErrorDialog}>
      <DialogWrapper>
        <CircleErrorIcon fontSize="64px" />
        <Row>
          <Typography fontWeight="bold" variant="h4">
            El formulario no pudo ser guardado
          </Typography>
          <Typography margin="16px 0 0" variant="body2">
            {errors?.length > 0
              ? 'Hay campos sin llenar, por favor completa toda la información necesaria y vuelve a intentar'
              : 'Lo sentimos, no hemos podido guardar tu formulario, por favor inténtalo en unos minutos más.'}
          </Typography>
        </Row>
        <Row>
          <Button color="primary" onClick={handleCloseErrorDialog} variant="outlined">
            Aceptar
          </Button>
        </Row>
      </DialogWrapper>
    </Dialog>
  )
}

export default QuoteErrorDraftDialog
